import React from "react";
import "./button.styles.scss";

const Button = ({ children, ...otherprops }) => {
  return (
    <button className="Custom-Button" {...otherprops}>
      {children}
    </button>
  );
};

export default Button;
